import React, { useContext } from "react";

import { Story } from "chq";

import LightboxStories from "components/common/gallery/LightboxStories";

import { CreatomateContext } from "./contexts/VideoStudioContext";
import { StoryModalContext } from "./contexts/StoryContext";

interface StoryModalProps {
  onSelectStory: (story: Story) => Promise<void>;
  onUnselectStory: (story: Story) => Promise<void>;
}

const StoryModal: React.FC<StoryModalProps> = ({ onSelectStory, onUnselectStory }) => {
  const {
    activeStory,
    changeModalIsOpen,
    handleThumbnailClick,
    modalIsOpen,
    onActiveStory,
    stories
  } = useContext(StoryModalContext);

  const { data } = useContext(CreatomateContext);
  const { onStoryUpdate } = data;

  const handleClose = () => {
    changeModalIsOpen(false);
  };

  const handleStoryUpdate = (updatedStory: Story) => {
    if (onStoryUpdate) onStoryUpdate(updatedStory);
    onActiveStory(updatedStory);
  };

  const handleSelectClicked = (story: Story) => {
    if (story.selected) {
      onUnselectStory(story);
    } else {
      onSelectStory(story);
    }
  };

  return (
    <>
      {activeStory && (
        <LightboxStories
          modalIsOpen={modalIsOpen}
          activeStory={activeStory}
          currentUserAnswered
          stories={stories}
          onClose={handleClose}
          onStoryChange={handleThumbnailClick}
          onStoryUpdate={handleStoryUpdate}
          onApproveClicked={handleSelectClicked}
          noActions
          videoStudio
          hideShareLink={undefined}
          onKeepAsInternalClicked={undefined}
        />
      )}
    </>
  );
};

export default StoryModal;
